import { IconTypes } from '@mode/shared/contract-common';
import { COLUMN_ICON_MAP, COLUMN_ICON_TYPE_MAP } from './icon.constants';

export function iconDataFromColumnType(type: any): string {
  if (typeof type !== 'string') {
    return COLUMN_ICON_MAP.unknown.data;
  }

  const iconType = COLUMN_ICON_TYPE_MAP[type.toLowerCase() as keyof IconTypes.ColumnIconTypeMap];
  return iconType in COLUMN_ICON_MAP ? COLUMN_ICON_MAP[iconType].data : COLUMN_ICON_MAP.unknown.data;
}

function iconFromColumnType(type: any) {
  if (typeof type !== 'string') {
    return COLUMN_ICON_MAP.unknown;
  }

  // Redshift late-binding views' column types may have numeric parameters
  // and so need to be matched with a regex: https://docs.amazonaws.cn/en_us/redshift/latest/dg/PG_GET_LATE_BINDING_VIEW_COLS.html#PG_GET_LATE_BINDING_VIEW_COLS-example
  // Though named "numeric", this is always decimal: https://docs.aws.amazon.com/redshift/latest/dg/r_Numeric_types201.html#r_Numeric_types201-decimal-or-numeric-type
  if (/^(numeric|decimal)\(\d+,\d+\)$/.test(type)) {
    return COLUMN_ICON_MAP.numeric;
  }
  // https://docs.aws.amazon.com/redshift/latest/dg/r_Character_types.html
  if (/^((national )?character( varying)?|n?(var)?char)\(\d+\)$/.test(type)) {
    return COLUMN_ICON_MAP.string;
  }

  const iconType = COLUMN_ICON_TYPE_MAP[type.toLowerCase() as keyof IconTypes.ColumnIconTypeMap];
  return iconType in COLUMN_ICON_MAP ? COLUMN_ICON_MAP[iconType] : COLUMN_ICON_MAP.unknown;
}

export function iconClassFromColumnType(type: any) {
  return iconFromColumnType(type).name;
}
